const directionPageArr = [
  { 
      page: "global",
      menu: 'userMenu',
      header: 'userHeader',
      footer: 'globalFooter'
  },
  {
      page: "HomePage",
      menu: false
  },
  {
      page: "UsersSignIn",
      menu: false
  },
  {
      page: "UsersLogin",
      menu: false
  },
  {
      page: "UsersForgotPassword",
      menu: false
  },
  {
      page: "TosPage",
      menu: "questMenu"
  },
  {
      page: "PrivacyPage",
      menu: "questMenu"
  },
  {
      page: "CookiePolicyPage",
      menu: "questMenu"
  },
  {
      page: "ContactPage",
      menu: "questMenu"
  },
  {
      page: "ErrorPage",
      menu: false
  },
  {
      page: "Error404",
      menu: false
  },
  {
      page: "AdminHome",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSettings",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSiteSettings",
      menu: "adminMenu",
      header: "adminHeader", 
      footer: "adminFooter"
  },
  {
      page: "AdminUsers",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminAnalytics",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminLogs",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchema",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchemaCreate",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchemaUpdate",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchemaDetail",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminContacts",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "TasksHome",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksCreate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksUpdate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksDetail",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksList",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksSearch",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "KanbanBoard",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "CalendarView",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidHome",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidCreate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidUpdate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidDetail",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidList",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidSearch",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "QuestionsPages",
      menu: false
  },
  {
      page: "QuestionsPagesId",
      menu: false,
      header: false,
      footer: false
  },
  {
      page: "QuestionsPagesPreview",
      menu: false,
      header: false,
      footer: false
  },
  {
      page: "QuestionsHome",
      menu: false
  },
  {
      page: "QuestionsCreate",
      menu: false
  },
  {
      page: "QuestionsUpdate",
      menu: false
  },
  {
      page: "QuestionsDetail",
      menu: false
  },
  {
      page: "QuestionsList",
      menu: false,
  },
  {
      page: "BooksHome",
      menu: false,
  },
  {
    page: "BooksDetail",
    menu: false,
  },
  {
    page: "BooksPreview",
    menu: false,
    header: false,
    footer: false
  },
  {
    page: "ActivitybooksHome",
    menu: false,
  },
  {
    page: "ActivitybooksDetail",
    menu: false,
  },
  {
    page: "ActivitybooksPreview",
    menu: false,
    header: false,
    footer: false
  },
  {
    page: "ActivitybooksCreate",
    menu: false,
  },
  {
    page: "ActivitybooksUpdate",
    menu: false,
  },
  {
    page: "ActivitybooksList",
    menu: false,
  },
  {
    page: "ActivitybooksSearch",
    menu: false,
  },
  {
    page: "SettingsHome",
    menu: false,
  },
  {
    page: "ImagesHome",
    menu: false,
  },
  {
    page: "ImagesList",
    menu: false,
  },
  {
    page: "ImagesDetail",
    menu: false,
  },
  {
    page: "ImagesCreate",
    menu: false,
  },
  {
    page: "ImagesUpdate",
    menu: false,
  },
  {
    page: "DemoHome",
    menu: false,
    header: false,
    footer: false
  },
  {
    page: "DemoDetail",
    menu: false,
    header: false,
    footer: false
  }
];

export default directionPageArr;
